import React from 'react';
import style from './style.scss';
import cls from 'classnames';

export default function SkeletonHeader() {
  return (
    <div className={cls(style.column)}>
      <div className={style.wrap}>
        <div className={style.avatar} />
        <div className={cls(style.column, style.column1)}>
          <div
            className={style.section}
            style={{
              width: 76,
            }}
          />
          <div
            className={style.section}
            style={{
              width: 45,
              marginTop: 10,
            }}
          />
        </div>
        <div className={style.column}>
          <div
            className={style.section}
            style={{
              width: 76,
            }}
          />
          <div
            className={style.section}
            style={{
              width: 45,
              marginTop: 10,
            }}
          />
        </div>
      </div>
    </div>
  );
}
